import { Button, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLMEUserIntegrations extends Layout {
    buttonAuthorize: Button;
    buttonRateviewUserAuthorize: Button;
    imageDatLogo: Image;
    imageTruckstopLogo: Image;
    labelAvailableServices: Label;
    labelDATResult: Label;
    labelRateViewDATResult: Label;
    labelTruckstopResult: Label;
    panelDATFields: Panel;
    panelDatRestLoadboardSelection: Panel;
    panelRateViewDat: Panel;
    panelRateViewSelection: Panel;
    panelServiceOptions: Panel;
    panelTruckstopFields: Panel;
    serviceSpacer: HorizontalSpacer;
    sourceLmeUserToken: DataSource;
    sourceUserSettings: DataSource;
    switchEnabledRateView: Switch;
    switchLoadBoard: Switch;
    textboxDATService: Textbox;
    textboxDatPassword: Textbox;
    textboxDatUserId: Textbox;
    textboxRateviewUserId: Textbox;
    textboxTruckstopPassword: Textbox;
    textboxTruckstopRESTService: Textbox;
    textboxTruckstopUserId: Textbox;
}
